// Retro-compatibilità: i "pacchetti" sono stati rimossi in favore del solo listino
// servizi. Questa utility fonde i pacchetti selezionati di un evento nell'array
// dei servizi (stessa forma { name, price, description, quantity, selected }),
// così prezzi e contenuti restano invariati per gli eventi già esistenti.
export function foldPackagesIntoServices(ev: any): void {
  const e = ev?.event;
  if (!e) return;

  const pkgs = e.packages ?? [];
  const selected = pkgs.filter((p: any) => p?.selected);

  if (selected.length) {
    if (!e.services) e.services = [];
    const names = new Set(e.services.map((s: any) => s?.name));
    for (const p of selected) {
      if (names.has(p.name)) continue; // evita duplicati
      e.services.push({
        name: p.name,
        price: p.price,
        description: p.description ?? '',
        quantity: p.quantity ?? 1,
        selected: true,
      });
    }
  }

  e.packages = [];
}
